import React from 'react'

const UnpaidWagesThankyou = () => {
  return (
    <>
      <h1>Thank you</h1>
      <p>
        Thank you for your enquiry, we will endeavour to respond to you within
        five to seven business days.
      </p>
    </>
  )
}

export default UnpaidWagesThankyou
